import { useEffect, useState } from 'react';
import './Home.css';
// import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Productcard from '../../Components/Productcard/Productcard';
import Collectioncard from '../../Components/Collectioncard/Collectioncard';
import { Link } from 'react-router-dom';
import Cartstrip from '../../Components/Cartstrip/Cartstrip';
import Slider from 'react-slick';

// const CustomPrevArrow = (props) => {
//     const { className, style, onClick } = props;
//     return (
//         <div
//             className={`${className} custom-arrow custom-prev-arrow`}
//             style={{ ...style, display: "block" }}
//             onClick={onClick}
//         />
//     );
// };

// const CustomNextArrow = (props) => {
//     const { className, style, onClick } = props;
//     return (
//         <div
//             className={`${className} custom-arrow custom-next-arrow`}
//             style={{ ...style, display: "block" }}
//             onClick={onClick}
//         />
//     );
// };

function Home() {

    // const [cattabs, setCattabs] = useState(1);
    // const [sellertab, setSellertab] = useState(1);
    const [prodata, setProdata] = useState([]);
    const [glassjars, setGlassjars] = useState([]);
    const [homedecors, setHomedecors] = useState([]);
    const [hiddencat, setHiddencat] = useState('d-none');
    const [showOfferPopup, setShowOfferPopup] = useState(false);
    const [copied, setCopied] = useState(false);

    useEffect(()=> { window.scrollTo(0, 0); }, []);

    useEffect(() => {
        const timer = setTimeout(() => setShowOfferPopup(true), 5000);
        return () => clearTimeout(timer);
    }, []);

    const handleCopyCode = () => {
        navigator.clipboard.writeText('FREEDOM15').then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };
    
    const herocaro = {
        infinite: true,
        dots: false,
        arrows: false,
        slidesToShow: 1,
        autoplay: true,
        slidesToScroll: 1,
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                },
            },
        ],
    }

    useEffect(()=> {
        fetch(`https://pentadeco.in/api/products/1/4/frosted tumbler`).then(res => res.json()).then(data => {
            if(data.success){
                setProdata(data.products);
            }
        }).catch(err => console.error('error occured while getting all the pros ', err));
    }, []);

    useEffect(()=> {
        fetch(`https://pentadeco.in/api/products/1/4/tote bag`).then(res => res.json()).then(data => {
            if(data.success){
                setGlassjars(data.products);
            }
        }).catch(err => console.error('error occured while getting all the pros ', err));
    }, []);

    useEffect(()=> {
        fetch(`https://pentadeco.in/api/products/1/4/mouse pad`).then(res => res.json()).then(data => {
            if(data.success){
                setHomedecors(data.products);
            }
        }).catch(err => console.error('error occured while getting all the pros ', err));
    }, []);

    // const splitFunc = (str)=> {
    //     const imgFst = str.split(',');
    //     console.log(imgFst)
    //     return imgFst;
    // }

    return (
        <div className='main-home overflow-hidden'>
<div className="container-fluid home-hero mx-auto m-0 p-0 pb-5">
                <img src="/assets/banner/Hero Section - Banner.webp" alt="Pentadeco Hero Banner" className="img-fluid w-100" />
                <div className="slider-wrap">
                        <div className="main-hero-div row align-items-center container mx-auto p-0 m-0 py-5">
                            <div className="col-md-12 text-center">
                                <div className="home-section-head mb-4">
                                    <span className="home-section-pill">SHOP</span>
                                    <h2 className="home-section-title">Browse by Category</h2>
                                </div>
                                <div className="d-flex justify-content-center flex-wrap p-0 mt-2">
                                    <div className="collection-card-wrapper p-2 mb-2">
                                        <Collectioncard name="Water bottle" img="/assets/categories/water-bottles.jpeg" />
                                    </div>
                                    <div className="collection-card-wrapper p-2 mb-2">
                                        <Collectioncard name="Tumblers" img="/assets/categories/tumblers.jpeg" />
                                    </div>
                                    <div className="collection-card-wrapper p-2 mb-2">
                                        <Collectioncard name="Mouse Pad" img="/assets/categories/547A9131.JPG" />
                                    </div>
                                    <div className="collection-card-wrapper p-2 mb-2">
                                        <Collectioncard name="Mug" img="/assets/categories/IMG_3112.JPG" />
                                    </div>
                                    <div className="collection-card-wrapper p-2 mb-2">
                                        <Collectioncard name="Bags" img="/assets/categories/547a8909.JPG" link="/product?category=tote+bag&page=1" />
                                    </div>
                                    {hiddencat === 'd-none' ? (
                                        <div className="collection-card-wrapper p-2 mb-2" onClick={() => setHiddencat('d-flex')}>
                                            <div className="main-collection-card-wrap">
                                                <div className="collection-cardd d-flex flex-column align-items-center rounded-brand-esm p-0 overflow-hidden cursor-pointer">
                                                    <div className="w-100">
                                                        <div className="cat-viewmore-card shadow-sm">
                                                            <div className="cat-viewmore-icon">
                                                                <i className="fi fi-ss-add"></i>
                                                            </div>
                                                            <p className="cat-viewmore-text">View More</p>
                                                        </div>
                                                    </div>
                                                    <div className="text-center w-100 mt-2">
                                                        <p className="mb-0 collection-btn body-font-bold text-capitalize lh-sm fs-sm">View More</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="collection-card-wrapper p-2 mb-2">
                                                <Collectioncard name="Wall Decor" img="/assets/categories/IMG_3067.JPG" />
                                            </div>
                                            <div className="collection-card-wrapper p-2 mb-2">
                                                <Collectioncard name="Bag Tag" img="/assets/categories/547A4378.JPG" />
                                            </div>
                                            <div className="collection-card-wrapper p-2 mb-2">
                                                <Collectioncard name="Mobile Stand" img="/assets/categories/mobile-stand.jpeg" />
                                            </div>
                                            <div className="collection-card-wrapper p-2 mb-2">
                                                <Collectioncard name="Money Bank" img="/assets/categories/547A4247.JPG" />
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                            {/* <div className="col-md-7">
                                <Slider {...herocaro} >
                                    <img src="/assets/new-hero-1.png" alt="" className="img-fluid"/>
                                    <img src="/assets/new-hero-2.png" alt="" className="img-fluid"/>
                                    <img src="/assets/new-hero-3.png" alt="" className="img-fluid"/>
                                </Slider>
                            </div> */}
                        </div>
                    </div>
                {/* <Slider {...herocaro}>
                    <div className="slider-wrap">
                        <div className="main-hero-div row align-items-center container mx-auto p-0 m-0">
                            <div className="col-md-6">
                                <p className="mb-0 text-dark text-muted body-font-semibold">SALE! UP TO 50% OFF!</p>
                                <p className="mb-0 hero-text text-dark body-font-semibold lh-sm">Home & Decor <br />Accessories</p>
                                <button className="btn btn-dark px-4 py-2 body-font-semibold rounded-3 mt-4">Shop Now</button>
                            </div>
                            <div className="col-md-6">
                                <img src="/assets/new-hero-img.png" alt="" className="img-fluid w-100" />
                            </div>
                        </div>
                    </div>
                    <div className="slider-wrap">
                        <div className="main-hero-div row align-items-center container mx-auto p-0 m-0">
                            <div className="col-md-6">
                                <p className="mb-0 text-dark text-muted body-font-semibold">SALE! UP TO 50% OFF!</p>
                                <p className="mb-0 hero-text text-dark body-font-semibold lh-sm">Afficient Kitchen <br />Accessories</p>
                                <button className="btn btn-dark px-4 py-2 body-font-semibold rounded-3 mt-4">Shop Now</button>
                            </div>
                            <div className="col-md-6">
                                <img src="/assets/hero-kitchen1.png" alt="" className="img-fluid w-100" />
                            </div>
                        </div>
                    </div>
                    <div className="slider-wrap">
                        <div className="main-hero-div row align-items-center container mx-auto p-0 m-0">
                            <div className="col-md-6">
                                <p className="mb-0 text-dark text-muted body-font-semibold">SALE! UP TO 50% OFF!</p>
                                <p className="mb-0 hero-text text-dark body-font-semibold lh-sm">Best Cleaning <br />Accessories</p>
                                <button className="btn btn-dark px-4 py-2 body-font-semibold rounded-3 mt-4">Shop Now</button>
                            </div>
                            <div className="col-md-6 p-0">
                                <img src="/assets/hero-cleaning1.png" alt="" className="img-fluid w-100" />
                            </div>
                        </div>
                    </div>
                </Slider> */}
            </div>

            {/* <div className="container">
                <div className="whats-new-card-wrap mt-5 pb-3">
                    <h2 className="text-center mb-4 fs-2 head-font-bold">EXPLORE CATEGORIES</h2>
                    <div className='row justify-content-center p-0 m-0 px-2'>
                        <div className="col-md-2 col-3 p-1">
                            <Collectioncard name="home decor" img="/assets/cat-home.png" />
                        </div>
                        <div className="col-md-2 col-3 p-1">
                            <Collectioncard name="kitchen decor" img="/assets/cat-kitchen.png" />
                        </div>
                        <div className="col-md-2 col-3 p-1">
                            <Collectioncard name="drinkware" img="/assets/cat-mugs.png" />
                        </div>
                        <div className="col-md-2 col-3 p-1">
                            <Collectioncard name="accessory" img="/assets/cat-personal.png" />
                        </div>
                    </div>
                </div>
            </div> */}
            
            {/* <div className="container-fluid p-0 pb-5 mt-5 pt-2">
                <div className="banner-wrap desk-banner px-3">
                    <Slider {...herocaro}>
                        <Link to="/product" className='nav-link'>
                            <img src="https://cdn.shopify.com/s/files/1/0550/8890/6475/files/home___decor_2_1.jpg?v=1634120765" alt="" className="img-fluid w-100 rounded-brand" />
                        </Link>
                        <Link to="/product" className='nav-link'>
                            <img src="https://cdn.shopify.com/s/files/1/0550/8890/6475/files/home___decor_2_1.jpg?v=1634120765" alt="" className="img-fluid w-100 rounded-brand" />
                        </Link>
                        <Link to="/product" className='nav-link'>
                            <img src="https://cdn.shopify.com/s/files/1/0550/8890/6475/files/home___decor_2_1.jpg?v=1634120765" alt="" className="img-fluid w-100 rounded-brand" />
                        </Link>
                    </Slider>
                </div>
                <div className="banner-wrap mob-banner">
                    <Slider {...herocaro}>
                        <Link to="/product" className='nav-link'>
                            <img src="https://d39vol41m7feya.cloudfront.net/1655709855-2.jpg" alt="" className="img-fluid w-100 rounded-brand" />
                        </Link>
                        <Link to="/product" className='nav-link'>
                            <img src="https://d39vol41m7feya.cloudfront.net/1655709855-2.jpg" alt="" className="img-fluid w-100 rounded-brand" />
                        </Link>
                        <Link to="/product" className='nav-link'>
                            <img src="https://d39vol41m7feya.cloudfront.net/1655709855-2.jpg" alt="" className="img-fluid w-100 rounded-brand" />
                        </Link>
                    </Slider>
                </div>
            </div> */}
            {/* <div className="container d-none">
                <div className="whats-new-div mt-5 pt-3">
                    <h2 className="text-center fs-2 body-font-bold">What's New</h2>
                    <div className="cat-tabs-wrap desk-tabs mt-4">
                        <div className="cat-tabs bg-light d-flex align-items-center rounded-brand w-max-content mx-auto p-2">
                            <div className="tab-back bg-white shadow-sm rounded-brand-sm" style={{ left: cattabs === 1 ? 10 : 100 * (cattabs - 1) }}></div>
                            <p className={`mb-0 me-3 px-3 py-1 body-font-semibold rounded-brand-sm cursor-pointer ${cattabs === 1 ? 'bg-dark shadow-sm text-white' : 'text-muted'}`} onClick={() => setCattabs(1)}>ALL</p>
                            <p className={`mb-0 me-3 px-3 py-1 body-font-semibold rounded-brand-sm cursor-pointer ${cattabs === 2 ? 'bg-dark shadow-sm text-white' : 'text-muted'}`} onClick={() => setCattabs(2)}>HOME</p>
                            <p className={`mb-0 me-3 px-3 py-1 body-font-semibold rounded-brand-sm cursor-pointer ${cattabs === 3 ? 'bg-dark shadow-sm text-white' : 'text-muted'}`} onClick={() => setCattabs(3)}>KITCHEN</p>
                            <p className={`mb-0 me-3 px-3 py-1 body-font-semibold rounded-brand-sm cursor-pointer ${cattabs === 4 ? 'bg-dark shadow-sm text-white' : 'text-muted'}`} onClick={() => setCattabs(4)}>KIDS</p>
                            <p className={`mb-0 me-0 px-3 py-1 body-font-semibold rounded-brand-sm cursor-pointer ${cattabs === 5 ? 'bg-dark shadow-sm text-white' : 'text-muted'}`} onClick={() => setCattabs(5)}>BATHROOM</p>
                        </div>
                    </div>
                    <div className="cat-tabs-wrap mob-tabs mt-4">
                        <div className="cat-tabs bg-light d-flex align-items-center rounded-brand w-max-content mx-auto p-2">
                            <div className="tab-back bg-white shadow-sm rounded-brand-sm" style={{ left: cattabs === 1 ? 10 : 100 * (cattabs - 1) }}></div>
                            <p className={`mb-0 me-3 px-3 py-1 body-font-semibold rounded-brand-sm cursor-pointer ${cattabs === 1 ? 'bg-dark shadow-sm text-white' : 'text-muted'}`} onClick={() => setCattabs(1)}>ALL</p>
                            <p className={`mb-0 me-3 px-3 py-1 body-font-semibold rounded-brand-sm cursor-pointer ${cattabs === 2 ? 'bg-dark shadow-sm text-white' : 'text-muted'}`} onClick={() => setCattabs(2)}>HOME</p>
                            <p className={`mb-0 me-0 px-3 py-1 body-font-semibold rounded-brand-sm cursor-pointer ${cattabs === 3 ? 'bg-dark shadow-sm text-white' : 'text-muted'}`} onClick={() => setCattabs(3)}>KIDS</p>
                        </div>
                    </div>
                </div>
            </div> */}

            {/* <div className="scrolling-container">
                <img src="/assets/infinite-banner.jpg" alt="banner" className="scrolling-img" />
                <img src="/assets/infinite-banner.jpg" alt="banner" className="scrolling-img" />
            </div> */}

            <div className="container-fluid">
                <div className="whats-new-card-wrap mt-5 pb-5">
                    <div className="home-section-head text-center mb-4">
                        <span className="home-section-pill">DRINKWARE</span>
                        <h2 className="home-section-title">Tumblers</h2>
                        <p className="home-section-sub">Stylish, personalised tumblers for every occasion</p>
                    </div>
                    <div className="new-cards row px-2">
                        {
                            prodata.length > 0 && (
                                prodata.slice(0, 4).map((pro, ind) => (
                                    <div key={ind} className="col-md-3 col-6 p-1">
                                        <Productcard coverimg={pro.images[0]} tag={pro.status} category={pro.category} saletxt={pro.spinningtxt} name={pro.name} price={pro.discountprice} preprice={pro.price} id={pro.proid} />
                                    </div>
                                ))
                            )
                        }
                    </div>
                    <div className="mx-auto W-100 text-center mt-3 cursor-pointer">
                        <Link to="/product?category=tumblers" className="btn btn-brand-secondary fs-esm mx-auto body-font-semibold px-4 rounded-pill">View All</Link>
                    </div>
                </div>
            </div>

            <div className="banner-wrap my-5">
                <div className="banner-strip"></div>
                <Link to="/product?category=tumblers">
                    <img src="/assets/banner/TUMBLERS.webp" alt="Tumblers" className="img-fluid w-100" />
                </Link>
            </div>

            <div className="container-fluid">
                <div className="whats-new-card-wrap mt-5 pb-5">
                    <div className="home-section-head text-center mb-4">
                        <span className="home-section-pill">BAGS</span>
                        <h2 className="home-section-title">Bags</h2>
                        <p className="home-section-sub">Personalised bags — carry your essentials in style</p>
                    </div>
                    <div className="new-cards row px-2">
                        {
                            glassjars.length > 0 && (
                                glassjars.map((pro, ind) => (
                                    <div key={ind} className="col-md-3 col-6 p-1">
                                        <Productcard coverimg={pro.images[0]} tag={pro.status} category={pro.category} saletxt={pro.spinningtxt} name={pro.name} price={pro.discountprice} preprice={pro.price} id={pro.proid} />
                                    </div>
                                ))
                            )
                        }
                    </div>
                    <div className="mx-auto W-100 text-center mt-3 cursor-pointer">
                        <Link to="/product?category=tote+bag&page=1" className="btn btn-brand-secondary fs-esm mx-auto body-font-semibold px-4 rounded-pill">View All</Link>
                    </div>
                </div>
            </div>

            <div className="banner-wrap my-5">
                <div className="banner-strip"></div>
                <Link to="/product?category=tote+bag&page=1">
                    <img src="/assets/banner/LUNCH BAGS.webp" alt="Bags" className="img-fluid w-100" />
                </Link>
            </div>

            <div className="bestseller-div mt-5">
                <div className="container-fluid">
                    <div className="whats-new-card-wrap mt-3 pb-5">
                        <div className="home-section-head text-center mb-4">
                            <span className="home-section-pill">WORKSPACE</span>
                            <h2 className="home-section-title">Mouse Pads</h2>
                            <p className="home-section-sub">Elevate your desk setup with style</p>
                        </div>
                        <div className="new-cards row">
                            {
                                homedecors.length > 0 && (
                                    homedecors.map((pro, ind) => (
                                        <div key={ind} className="col-md-3 col-6 p-1">
                                            <Productcard coverimg={pro.images[0]} tag={pro.status} category={pro.category} saletxt={pro.spinningtxt} name={pro.name} price={pro.discountprice} preprice={pro.price} id={pro.proid} />
                                        </div>
                                    ))
                                )
                            }
                        </div>
                        <div className="mx-auto w-max-content mt-3">
                            <Link to="/product?category=mouse+pad&page=1" className="btn btn-brand-secondary fs-esm mx-auto body-font-semibold px-4 rounded-pill">View All</Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="banner-wrap my-5">
                <div className="banner-strip"></div>
                <Link to="/product?category=mouse+pad&page=1">
                    <img src="/assets/banner/MOUSE PADS.webp" alt="Mouse Pads" className="img-fluid w-100" />
                </Link>
            </div>

            <div className="container mb-5">
                <div className="home-section-head text-center mb-4">
                    <span className="home-section-pill">SUPPORT</span>
                    <h2 className="home-section-title">Got Questions?</h2>
                    <p className="home-section-sub">Everything you need to know, answered here</p>
                </div>
                <div className="faqs-wrapper">
                    <div className="accordion rounded-brand" id="accordionExample">

                        {/* FAQ 1 */}
                        <div className="accordion-item rounded-brand mb-2 border-0">
                            <h2 className="accordion-header rounded-brand border-0">
                                <button
                                    className="accordion-button border-0 shadow-none rounded-brand"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapse1"
                                    aria-expanded="true"
                                    aria-controls="collapse1"
                                >
                                    How long does shipping take?
                                </button>
                            </h2>
                            <div
                                id="collapse1"
                                className="accordion-collapse collapse"
                                data-bs-parent="#accordionExample"
                            >
                                <div className="accordion-body">
                                    We usually deliver within <strong>3–7 working days</strong> depending on your location. Metro cities may get faster delivery.
                                </div>
                            </div>
                        </div>

                        {/* FAQ 2 */}
                        <div className="accordion-item rounded-brand mb-2 border-0">
                            <h2 className="accordion-header rounded-brand border-0">
                                <button
                                    className="accordion-button border-0 shadow-none rounded-brand collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapse2"
                                    aria-expanded="false"
                                    aria-controls="collapse2"
                                >
                                    Do you charge for shipping?
                                </button>
                            </h2>
                            <div
                                id="collapse2"
                                className="accordion-collapse collapse"
                                data-bs-parent="#accordionExample"
                            >
                                <div className="accordion-body">
                                    We offer <strong>free shipping on orders above ₹999</strong>. For smaller orders, a minimal delivery charge may apply.
                                </div>
                            </div>
                        </div>

                        {/* FAQ 3 */}
                        <div className="accordion-item rounded-brand mb-2 border-0">
                            <h2 className="accordion-header rounded-brand border-0">
                                <button
                                    className="accordion-button border-0 shadow-none rounded-brand collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapse3"
                                    aria-expanded="false"
                                    aria-controls="collapse3"
                                >
                                    Do you offer Cash on Delivery (COD)?
                                </button>
                            </h2>
                            <div
                                id="collapse3"
                                className="accordion-collapse collapse"
                                data-bs-parent="#accordionExample"
                            >
                                <div className="accordion-body">
                                    Yes, COD is available across India for most pin codes.
                                </div>
                            </div>
                        </div>

                        {/* FAQ 4 */}
                        <div className="accordion-item rounded-brand mb-2 border-0">
                            <h2 className="accordion-header rounded-brand border-0">
                                <button
                                    className="accordion-button border-0 shadow-none rounded-brand collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapse4"
                                    aria-expanded="false"
                                    aria-controls="collapse4"
                                >
                                    How can I track my order?
                                </button>
                            </h2>
                            <div
                                id="collapse4"
                                className="accordion-collapse collapse"
                                data-bs-parent="#accordionExample"
                            >
                                <div className="accordion-body">
                                    Once your order is shipped, you will receive a <strong>tracking link via email/SMS</strong>. You can track the live status of your order anytime.
                                </div>
                            </div>
                        </div>

                        {/* FAQ 5 */}
                        <div className="accordion-item rounded-brand mb-2 border-0">
                            <h2 className="accordion-header rounded-brand border-0">
                                <button
                                    className="accordion-button border-0 shadow-none rounded-brand collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapse5"
                                    aria-expanded="false"
                                    aria-controls="collapse5"
                                >
                                    What is your return policy?
                                </button>
                            </h2>
                            <div
                                id="collapse5"
                                className="accordion-collapse collapse"
                                data-bs-parent="#accordionExample"
                            >
                                <div className="accordion-body">
                                    You can return products within <strong>7 days of delivery</strong> if they are damaged, defective, or not as described.
                                </div>
                            </div>
                        </div>

                        {/* FAQ 6 */}
                        <div className="accordion-item rounded-brand mb-2 border-0">
                            <h2 className="accordion-header rounded-brand border-0">
                                <button
                                    className="accordion-button border-0 shadow-none rounded-brand collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapse6"
                                    aria-expanded="false"
                                    aria-controls="collapse6"
                                >
                                    How safe is my payment?
                                </button>
                            </h2>
                            <div
                                id="collapse6"
                                className="accordion-collapse collapse"
                                data-bs-parent="#accordionExample"
                            >
                                <div className="accordion-body">
                                    We use <strong>100% secure payment gateways</strong> with encryption to ensure a safe and smooth checkout.
                                </div>
                            </div>
                        </div>

                        {/* FAQ 7 */}
                        <div className="accordion-item rounded-brand mb-2 border-0">
                            <h2 className="accordion-header rounded-brand border-0">
                                <button
                                    className="accordion-button border-0 shadow-none rounded-brand collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapse7"
                                    aria-expanded="false"
                                    aria-controls="collapse7"
                                >
                                    Do you take bulk or custom orders?
                                </button>
                            </h2>
                            <div
                                id="collapse7"
                                className="accordion-collapse collapse"
                                data-bs-parent="#accordionExample"
                            >
                                <div className="accordion-body">
                                    Yes, we do accept <strong>bulk & corporate orders</strong>. For customization, kindly contact our support team.
                                </div>
                            </div>
                        </div>

                        {/* FAQ 8 */}
                        <div className="accordion-item rounded-brand mb-2 border-0">
                            <h2 className="accordion-header rounded-brand border-0">
                                <button
                                    className="accordion-button border-0 shadow-none rounded-brand collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapse8"
                                    aria-expanded="false"
                                    aria-controls="collapse8"
                                >
                                    How can I reach your support team?
                                </button>
                            </h2>
                            <div
                                id="collapse8"
                                className="accordion-collapse collapse"
                                data-bs-parent="#accordionExample"
                            >
                                <div className="accordion-body">
                                    You can contact us via:
                                    <br />
                                    <strong>Email:</strong> <a href="mailto:pentadeco@gmail.com">pentadeco@gmail.com</a>
                                    <br />
                                    <strong>WhatsApp:</strong> +91 7738494171, +91 8433551012, +91 9273158535
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="container mb-5 mt-2">
                <div className="home-section-head text-center mb-4">
                    <span className="home-section-pill">OUR PROMISE</span>
                    <h2 className="home-section-title">Why Choose Us</h2>
                </div>
                <div className="row g-3">
                    <div className="col-md-3 col-6">
                        <div className="feature-card">
                            <div className="feature-icon-wrap">
                                <i className="fi fi-rs-shipping-fast"></i>
                            </div>
                            <p className="feature-name">Free & Fast Shipping</p>
                            <p className="feature-desc">Swift delivery to your doorstep so you can enjoy your decor without delay.</p>
                        </div>
                    </div>
                    <div className="col-md-3 col-6">
                        <div className="feature-card">
                            <div className="feature-icon-wrap">
                                <i className="fi fi-rs-badge-check"></i>
                            </div>
                            <p className="feature-name">Quality Products</p>
                            <p className="feature-desc">Superior materials and attention to detail, guaranteeing a premium finish.</p>
                        </div>
                    </div>
                    <div className="col-md-3 col-6">
                        <div className="feature-card">
                            <div className="feature-icon-wrap">
                                <i className="fi fi-rs-sparkles"></i>
                            </div>
                            <p className="feature-name">Amazing Designs</p>
                            <p className="feature-desc">Stylish, trendy designs that add personality and uplift your living space.</p>
                        </div>
                    </div>
                    <div className="col-md-3 col-6">
                        <div className="feature-card">
                            <div className="feature-icon-wrap">
                                <i className="fi fi-rs-lock"></i>
                            </div>
                            <p className="feature-name">Safe Checkouts</p>
                            <p className="feature-desc">Shop with confidence using our fully secure payment options.</p>
                        </div>
                    </div>
                </div>
            </div>

            <Cartstrip/>

            {/* Independence Day Offer Popup */}
            {showOfferPopup && (
                <div className="offer-popup-overlay" onClick={() => setShowOfferPopup(false)}>
                    <div className="offer-popup-sheet" onClick={e => e.stopPropagation()}>

                        {/* Colored ticket header */}
                        <div className="offer-sheet-header">
                            <div className="offer-flag-stripe">
                                <span className="oflag-saffron"></span>
                                <span className="oflag-white"></span>
                                <span className="oflag-green"></span>
                            </div>
                            <button className="offer-popup-close" onClick={() => setShowOfferPopup(false)}>
                                <i className="fi fi-rs-cross-small"></i>
                            </button>
                            <p className="offer-header-eyebrow">✦ Independence Day Special ✦</p>
                            <p className="offer-header-discount">15% OFF</p>
                            <p className="offer-header-sub">On ALL products — One time offer!</p>
                        </div>

                        {/* Ticket perforation edge */}
                        <div className="offer-ticket-edge">
                            <div className="offer-notch offer-notch-l"></div>
                            <div className="offer-dashes"></div>
                            <div className="offer-notch offer-notch-r"></div>
                        </div>

                        {/* White body */}
                        <div className="offer-sheet-body">
                            <p className="offer-code-label">Use coupon code at checkout</p>
                            <div className="offer-code-row">
                                <span className="offer-code-box">FREEDOM15</span>
                                <button className="offer-copy-btn" onClick={handleCopyCode}>
                                    {copied
                                        ? <><i className="fi fi-rs-check"></i> Copied!</>
                                        : <><i className="fi fi-rs-copy"></i> Copy</>
                                    }
                                </button>
                            </div>
                            <Link to="/product" className="offer-shop-btn" onClick={() => setShowOfferPopup(false)}>
                                Shop Now &nbsp;<i className="fi fi-rs-arrow-right"></i>
                            </Link>
                            <p className="offer-sheet-note">Limited time offer. Valid on all products.</p>
                        </div>

                    </div>
                </div>
            )}

        </div>
    )
}

export default Home;